import { render, staticRenderFns } from "./ClaimHelpList.vue?vue&type=template&id=06d4d308&"
import script from "./ClaimHelpList.vue?vue&type=script&lang=js&"
export * from "./ClaimHelpList.vue?vue&type=script&lang=js&"
import style0 from "./ClaimHelpList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports